import React, { useContext } from 'react';
import '../../stylesheets/stylesLayout/sign-up.scss';
import { ContextSignUp } from '../../contexts/SignUpContext';
import Steps from '../Steps';
import SignUpInformation from './SignUpInformation';
import SignUpStepsContainer from './SignUpStepsContainer';

const SignUp = () => {
    const { stepsCount, step, setStep } = useContext(ContextSignUp);
    return (
        <div className='sign-up__container'>
            <div className='steps__section'>
                <Steps
                    stepsCount={stepsCount}
                    step={step}
                    setStep={setStep}
                    disabledSteps={step === stepsCount}
                />
            </div>
            <div className='sign-up__content'>
                <SignUpInformation />
                <SignUpStepsContainer />
            </div>
        </div>
    );
};

export default SignUp;
